import * as automatictaskList from './AutomatictaskList';
import * as automatictaskItem from './automaticTaskItem';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    automatictaskList: automatictaskList.IState
    automatictaskItem: automatictaskItem.IState
}

export const ActionCreators = {
    automatictaskList: automatictaskList.ActionCreators,
    automatictaskItem: automatictaskItem.ActionCreators
}

export const Reducers = combineReducers<IState>({
    automatictaskList: automatictaskList.Reducers,
    automatictaskItem: automatictaskItem.Reducers
});

export function* sagas() {
    yield all([
        fork(automatictaskList.sagas),
        fork(automatictaskItem.sagas)
    ]);
}
